// eslint-disable-next-line import/prefer-default-export
export const priceValidator = (t, minPrice, maxPrice, validateEmpty = true) => (input) => {
    let err = null;
    const parsedInput = parseFloat(input);
    if (validateEmpty && input.trim().length === 0) {
        err = t('auctions.bids-list.validation.price-empty');
    } else if (!input.match(/^(-?\d+(\.\d{0,2})?)?$/)) {
        err = t('auctions.bids-list.validation.price-invalid-number');
    } else if ((minPrice && parsedInput < minPrice) || (maxPrice && parsedInput > maxPrice)) {
        err = t('auctions.bids-list.validation.price-out-of-range', { minPrice: minPrice ? minPrice.toFixed(2) : '-', maxPrice: maxPrice ? maxPrice.toFixed(2) : '-' });
    }
    return err;
};
